import React from 'react';
import ServiceDetailPage from '../ServiceDetailPage';

const indicatorConfig = {
  pageClass: 'indicator-detail-page',
  eyebrow: 'AI indicator',
  title: 'AI chart confirmation.',
  copy: 'Use the CRYPTOXNFT indicator as a technical-analysis layer for trend, timing, and confirmation. It supports chart review; it does not replace your plan.',
  actions: [
    { label: 'Buy Indicator', to: '/services/indicator/payment' },
    { label: 'Ask in Telegram', href: 'https://t.me/cryptoxnfts', variant: 'secondary' },
  ],
  metrics: [
    { value: '199 USDT', label: 'Indicator access', note: 'Manual redemption' },
    { value: 'TA layer', label: 'Chart support', note: 'Trend and timing' },
    { value: 'Any pair', label: 'Flexible use', note: 'Confirm manually' },
  ],
  visual: {
    kicker: 'INDICATOR VIEW',
    badge: 'CHARTS',
    label: 'AI indicator chart preview',
    rows: [
      { label: 'Trend', title: 'Direction check', meta: '4H' },
      { label: 'Timing', title: 'Prompt zone', meta: '1D' },
      { label: 'Risk', title: 'Invalidation first', meta: 'Manual' },
    ],
    chips: ['Trend filter', 'Timing prompt', 'Manual confirmation'],
    media: {
      src: '/assets/images/services/indicator/indicatorSOL.png',
      alt: 'SOL indicator screenshot',
      label: 'SOL/USDT indicator view',
    },
  },
  featuresIntro: {
    eyebrow: 'How it helps',
    title: 'A cleaner way to inspect the chart.',
    copy: 'The value is consistency: the same visual logic across pairs so you can decide faster and with clearer invalidation.',
  },
  features: [
    {
      label: 'Trend',
      title: 'Read direction',
      copy: 'Use the overlay to check whether the chart supports your market view.',
    },
    {
      label: 'Timing',
      title: 'Mark action zones',
      copy: 'Buy and sell prompts become review points, not automatic entries.',
    },
    {
      label: 'Risk',
      title: 'Keep control',
      copy: 'Sizing, leverage, invalidation, and whether to trade remain your decisions.',
    },
  ],
  flowIntro: {
    eyebrow: 'Use process',
    title: 'Screen first. Trade second.',
    copy: 'The indicator works best when it is part of a repeatable review process instead of a shortcut around risk.',
  },
  steps: [
    {
      title: 'Check chart structure',
      copy: 'Start with trend, levels, and market context before reading any prompt.',
    },
    {
      title: 'Validate the prompt',
      copy: 'Use the indicator as confirmation, then compare it with your invalidation plan.',
    },
    {
      title: 'Redeem access',
      copy: 'After payment, send proof to Telegram admin for manual activation.',
    },
  ],
  proofIntro: {
    eyebrow: 'Chart examples',
    title: 'See the tool in actual market screenshots.',
    copy: 'Examples show how the indicator appears on charts and how historical proof previews are presented.',
  },
  proofItems: [
    {
      src: '/assets/images/services/indicator/indicatorOP.png',
      alt: 'OP indicator screenshot',
      label: 'OP/USDT chart',
    },
    {
      src: '/assets/images/services/indicator/indicatorETH.png',
      alt: 'ETH indicator screenshot',
      label: 'ETH/USDT chart',
    },
    {
      src: '/assets/images/services/indicator/indicatorLINK.png',
      alt: 'LINK indicator screenshot',
      label: 'LINK/USDT chart',
    },
    {
      src: '/assets/images/services/indicator/pnl/ORDI.png',
      alt: 'ORDI historical PNL screenshot',
      label: 'Historical example',
    },
    {
      src: '/assets/images/services/indicator/pnl/FET.png',
      alt: 'FET historical PNL screenshot',
      label: 'Historical example',
    },
    {
      src: '/assets/images/services/indicator/pnl/VET.png',
      alt: 'VET historical PNL screenshot',
      label: 'Historical example',
    },
  ],
  notice: 'Indicator screenshots and historical examples are educational context only. They do not guarantee future outcomes or remove market risk.',
  finalCta: {
    eyebrow: 'Next step',
    title: 'Add the chart layer when your process is ready.',
    copy: 'Buy access through the official payment route, or ask questions in the free Telegram first.',
    actions: [
      { label: 'Buy Indicator', to: '/services/indicator/payment' },
      { label: 'Free Telegram', href: 'https://t.me/cryptoxnfts', variant: 'secondary' },
    ],
  },
};

function Indicator() {
  return <ServiceDetailPage {...indicatorConfig} />;
}

export default Indicator;
